import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import L from "leaflet";
import { autorun, computed, observable, makeObservable } from "mobx";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import CesiumEvent from "terriajs-cesium/Source/Core/Event";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
export const isImageryProviderGridLayer = obj => {
  return typeof obj.requestImageForCanvas === "function";
};
let ImageryProviderLeafletGridLayer = (_class = class ImageryProviderLeafletGridLayer extends L.GridLayer {
  constructor(leaflet, imageryProvider, options) {
    super(Object.assign(options, {
      async: true,
      tileSize: 256
    }));
    this.leaflet = leaflet;
    this.imageryProvider = imageryProvider;
    _defineProperty(this, "errorEvent", new CesiumEvent());
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "_usable", false);
    _defineProperty(this, "_delayedUpdate", undefined);
    _defineProperty(this, "_zSubtract", 0);
    _defineProperty(this, "_previousCredits", []);
    _initializerDefineProperty(this, "splitDirection", _descriptor, this);
    _initializerDefineProperty(this, "splitPosition", _descriptor2, this);
    makeObservable(this);

    // Handle splitter rection (and disposing reaction)
    let disposeSplitterReaction;
    this.on("add", () => {
      if (!disposeSplitterReaction) {
        disposeSplitterReaction = this._reactToSplitterChange();
      }
    });
    this.on("remove", () => {
      if (disposeSplitterReaction) {
        disposeSplitterReaction();
        disposeSplitterReaction = undefined;
      }
    });
  }
  _reactToSplitterChange() {
    return autorun(() => {
      const container = this.getContainer();
      if (container === null) {
        return;
      }
      if (this.splitDirection === SplitDirection.LEFT) {
        const {
          left: clipLeft
        } = this._clipsForSplitter;
        container.style.clip = clipLeft;
      } else if (this.splitDirection === SplitDirection.RIGHT) {
        const {
          right: clipRight
        } = this._clipsForSplitter;
        container.style.clip = clipRight;
      } else {
        container.style.clip = "auto";
      }
    });
  }
  get _clipsForSplitter() {
    let clipLeft = "";
    let clipRight = "";
    let clipPositionWithinMap;
    let clipX;
    if (this.leaflet.size && this.leaflet.nw && this.leaflet.se) {
      clipPositionWithinMap = this.leaflet.size.x * this.splitPosition;
      clipX = Math.round(this.leaflet.nw.x + clipPositionWithinMap);
      clipLeft = "rect(" + [this.leaflet.nw.y, clipX, this.leaflet.se.y, this.leaflet.nw.x].join("px,") + "px)";
      clipRight = "rect(" + [this.leaflet.nw.y, this.leaflet.se.x, this.leaflet.se.y, clipX].join("px,") + "px)";
    }
    return {
      left: clipLeft,
      right: clipRight,
      clipPositionWithinMap: clipPositionWithinMap,
      clipX: clipX
    };
  }
  createTile(tilePoint, done) {
    const canvas = L.DomUtil.create("canvas", "leaflet-tile");
    const size = this.getTileSize();
    canvas.width = size.x;
    canvas.height = size.y;
    const n = this.imageryProvider.tilingScheme.getNumberOfXTilesAtLevel(tilePoint.z);
    this.imageryProvider.requestImageForCanvas(CesiumMath.mod(tilePoint.x, n), tilePoint.y, tilePoint.z, canvas).then(function (canvas) {
      done(undefined, canvas);
    });
    return canvas; // Not yet drawn on, but Leaflet requires the tile
  }
  getFeaturePickingCoords(map, longitudeRadians, latitudeRadians) {
    const ll = new Cartographic(CesiumMath.negativePiToPi(longitudeRadians), latitudeRadians, 0.0);
    const level = Math.round(map.getZoom());
    const tilingScheme = this.imageryProvider.tilingScheme;
    const coords = tilingScheme.positionToTileXY(ll, level);
    return {
      x: coords.x,
      y: coords.y,
      level: level
    };
  }
  pickFeatures(x, y, level, longitudeRadians, latitudeRadians) {
    return this.imageryProvider.pickFeatures(x, y, level, longitudeRadians, latitudeRadians);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "splitDirection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return SplitDirection.NONE;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "splitPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.5;
  }
}), _applyDecoratedDescriptor(_class.prototype, "_clipsForSplitter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_clipsForSplitter"), _class.prototype), _class);
export { ImageryProviderLeafletGridLayer as default };